import { useState } from "react";
import * as api from "../../api";

/* F3B-6a — Pago parcial extraído VERBATIM desde App.js.
 * Dependencias inyectadas: showToast, orders, setOrders, setUser. */
export function usePartialPayment({ showToast, orders, setOrders, setUser, user,
  paymentMethods, exchangeRate }) {
  const creditBalance = () => Number(user?.credit_balance_bs || 0);
  // Complete partial payment modal
  const [completePartialOrder, setCompletePartialOrder] = useState(null);
  const [partialAmount, setPartialAmount] = useState("");
  const [partialRef, setPartialRef] = useState("");
  const [partialFile, setPartialFile] = useState(null);
  const [partialFileName, setPartialFileName] = useState("");
  const [completingPartial, setCompletingPartial] = useState(false);
  const [partialErrors, setPartialErrors] = useState([]);
  // Método de pago del abono y uso de saldo a favor.
  const [partialPmId, setPartialPmId] = useState("");
  const [partialUseCredit, setPartialUseCredit] = useState(false);

  const openCompletePartial = (order) => {
    setCompletePartialOrder(order);
    setPartialAmount("");
    setPartialRef("");
    setPartialFile(null);
    setPartialFileName("");
    setPartialErrors([]);
    setPartialPmId(order?.paymentMethodId || "");
    setPartialUseCredit(false);
  };

  const remainingForOrder = (o) => {
    if (!o) return 0;
    const already = (o.paidAmountBs || 0) + (o.additionalPayments || []).reduce((a, p) => a + (p.paidAmountBs || 0), 0);
    const expected = (o.priceBs || 0) - (o.creditApplied || 0);
    return Math.max(0, expected - already);
  };

  const handleSubmitPartialPayment = async (e) => {
    e.preventDefault();
    setPartialErrors([]);
    const remaining = remainingForOrder(completePartialOrder);
    const creditToUse = partialUseCredit ? Math.min(creditBalance(), remaining) : 0;
    const creditCoversAll = creditToUse >= remaining - 0.5;

    if (!creditCoversAll && (!partialAmount || !partialFile)) {
      showToast("Faltan Datos", "Completa monto y adjunta el comprobante", "error");
      return;
    }
    if (!creditCoversAll && !partialPmId) {
      showToast("Falta el método", "Elige a dónde hiciste el pago", "error");
      return;
    }
    setCompletingPartial(true);
    try {
      const selectedMethod = (paymentMethods || []).find((method) => method.id === partialPmId);
      const paymentCurrency = selectedMethod?.type === "USD_PLATFORM" ? "USD" : "BS";
      const amount = parseFloat(partialAmount || 0);
      const res = await api.completePartialPayment({
        orderId: completePartialOrder.id,
        paidAmountBs: creditCoversAll && !partialFile ? 0 : (paymentCurrency === "BS" ? amount : null),
        paidAmountUsd: creditCoversAll && !partialFile ? null : (paymentCurrency === "USD" ? amount : null),
        paymentCurrency,
        quotedExchangeRate: exchangeRate,
        proofFile: creditCoversAll && !partialFile ? null : partialFile,
        paymentMethodId: partialPmId,
        useCredit: partialUseCredit,
      });
      setOrders(orders?.map(o => o.id === res.order.id ? res.order : o));
      if (typeof res.new_credit_balance_bs === "number") {
        setUser(u => u ? { ...u, credit_balance_bs: res.new_credit_balance_bs } : u);
      }
      setCompletePartialOrder(null);
      if (res.is_partial) {
        const usd = Number(exchangeRate) > 0 ? res.shortage_bs / Number(exchangeRate) : 0;
        showToast("Pago Registrado", `Aún faltan Bs ${Math.round(res.shortage_bs)} ($${usd.toFixed(2)}) para completar el pedido.`, "success");
      } else {
        showToast("¡Pedido Completado!", "Tu pedido pasó a estado Pendiente. Verificaremos pronto.", "success");
      }
    } catch (err) {
      const errs = err.data?.validation_errors || [err.data?.detail?.message || err.message];
      setPartialErrors(errs);
      showToast("Comprobante Inválido", errs[0] || "Verifica los datos del pago", "error");
    } finally {
      setCompletingPartial(false);
    }
  };

  return {
    completePartialOrder, setCompletePartialOrder,
    partialAmount, setPartialAmount, partialRef, setPartialRef,
    partialFile, setPartialFile, partialFileName, setPartialFileName,
    completingPartial, partialErrors,
    partialPmId, setPartialPmId,
    partialUseCredit, setPartialUseCredit,
    openCompletePartial, remainingForOrder, handleSubmitPartialPayment,
  };
}
